import { apiLegacy } from "@/services/api-legacy";
import {
  GetPrivateRoomsBySpacesProps,
  GetPrivateRoomsBySpacesResponseApi,
} from "./get-privaterooms-by-space.types";

export const GetPrivateRoomsBySpaceApi = async ({
  space_id,
}: GetPrivateRoomsBySpacesProps) => {
  const response: GetPrivateRoomsBySpacesResponseApi = await apiLegacy.get(
    `/v0/privaterooms?limit=10000&offset=0&space_id=${space_id}`,
  );

  const privateRooms = response.data._embedded["private-rooms"].map((item) => {
    return {
      id: item.privateroom.id,
      name: `${item.space.name} - id:${item.privateroom.id} - Name:${item.privateroom.label} - Capacity: ${item.privateroom.capacity} - Price: ${item.privateroom.monthly_price}`,
    };
  });

  return {
    data: privateRooms,
  };
};
